import { useMemo } from "react";

import { useGetIsShowSegmentModalQuery } from "@/graphql/segment/segment.hooks";
import { GraphqlMappedError } from "@/services/graphqlErrorService";

interface IUseGetChooseUseCaseModalReturnedValue {
  data: {
    isShow: boolean;
  };
  loading: boolean;
  error?: GraphqlMappedError;
}

function useGetChooseUseCaseModal(): IUseGetChooseUseCaseModalReturnedValue {
  const { data, loading, error } = useGetIsShowSegmentModalQuery();

  return useMemo(
    () => ({
      data: {
        isShow: data?.user.isShowSegmentModal || false,
      },
      loading,
      error: error && GraphqlMappedError.from(error),
    }),
    [data, loading, error]
  );
}

export default useGetChooseUseCaseModal;
